<aside id="cixorSidebar" class="sidebar" [ngClass]="{'sidebar--collapsed': isCollapsed}" role="navigation"
  aria-label="Primary">

  <!-- Collapsed State: Show toggle button and icon-only nav -->
  <div class="sidebar_collapsed-content" *ngIf="isCollapsed">
    <!-- Toggle Button -->
    <button type="button" class="sidebar_toggle-btn sidebar_toggle-btn--center" (click)="toggleSidebar()"
      [attr.aria-expanded]="!isCollapsed" aria-label="Expand sidebar">
      <i class="bi bi-chevron-right"></i>
    </button>

    <!-- Icon-only Navigation -->
    <nav class="sidebar_nav-collapsed">
      <ul class="sidebar_icon-list">
        <!-- Home -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.Home | canModule : 'VIEW'">
          <a routerLink="dashboard" routerLinkActive="is-active" class="sidebar_icon-link" title="Home">
            <i class="bi bi-house"></i>
          </a>
        </li>

        <!-- ADMIN Section -->
        <!-- Company Details -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.CompanyDetails | canModule : 'VIEW'">
          <a routerLink="/admin/company-details" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Company Details">
            <i class="bi bi-building"></i>
          </a>
        </li>
        <!-- User Management - Existing Users -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.ExistingUsers | canModule : 'VIEW'">
          <a routerLink="/admin/user-management/existing-users" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Existing Users">
            <i class="bi bi-people-fill"></i>
          </a>
        </li>
        <!-- User Management - New User Requests -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.NewUserRequests | canModule : 'VIEW'">
          <a routerLink="/admin/user-management/new-user-requests" routerLinkActive="is-active"
            class="sidebar_icon-link" title="New User Requests">
            <i class="bi bi-person-plus"></i>
          </a>
        </li>

        <!--=======================================================================================================-->
        <!-- TRANSACTION Section  -->
        <!-- ===================================================================================================== -->
        <!-- Pay Day Quick View -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.PayDayQuickView | canModule : 'VIEW'">
          <a routerLink="/transactions/pay-day-quick-view" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Pay Day Quick View">
            <i class="bi bi-calendar-check"></i>
          </a>
        </li>
        <!-- Earn Wage Withdrawal -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.EarnWageWithdrawal | canModule : 'VIEW'">
          <a routerLink="/transactions/earned-wage-withdrawals" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Earn Wage Withdrawal">
            <i class="bi bi-cash"></i>
          </a>
        </li>
        <!-- Wage Withdrawal Rollovers -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.WageWithdrawalRollovers | canModule : 'VIEW'">
          <a routerLink="/transactions/wage-withdrawal-rollovers" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Wage Withdrawal Rollovers">
            <i class="bi bi-arrow-repeat"></i>
          </a>
        </li>
        <!-- Total Wages -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.TotalWages | canModule : 'VIEW'">
          <a routerLink="/transactions/total-wages" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Total Wages">
            <i class="bi bi-wallet2"></i>
          </a>
        </li>
        <!-- CIXOR Payments -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.CIXORPayments | canModule : 'VIEW'">
          <a routerLink="/transactions/cixor-payments" routerLinkActive="is-active" class="sidebar_icon-link"
            title="CIXOR Payments">
            <i class="bi bi-credit-card"></i>
          </a>
        </li>
        <!-- LateFee Payments -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.LatePaymentFees | canModule : 'VIEW'">
          <a routerLink="/transactions/late-payment-fees" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Late Payment Fees">
            <i class="bi bi-receipt-cutoff"></i>
          </a>
        </li>
        <!-- Wages - Withdrawals - Rollovers -->
        <li class="sidebar_icon-item" *ngIf="ModuleIds.WagesWithdrawalsRollovers | canModule : 'VIEW'">
          <a routerLink="/transactions/wages-withdrawals-rollovers" routerLinkActive="is-active"
            class="sidebar_icon-link" title="Wages - Withdrawals - Rollovers">
            <i class="bi bi-graph-up"></i>
          </a>
        </li>

        <!-- HR LINK Section Header (Lock/Unlock) -->
        <li class="sidebar_icon-item sidebar_hr-divider" *ngIf="
          (ModuleIds.EmployeeManagement | canModule : 'VIEW') ||
          (ModuleIds.AbsenteeRecorder | canModule : 'VIEW') ||
          (ModuleIds.HRAdmin | canModule : 'VIEW') ||
          (ModuleIds.PayrollManagement | canModule : 'VIEW')
        ">
          <button type="button" class="sidebar_icon-link sidebar_hr-lock-btn" (click)="handleHrLinkClick()"
            [title]="isHrUnlocked ? 'Lock HR Access' : 'Unlock HR Access'" [ngClass]="{'is-unlocked': isHrUnlocked}">
            <i class="bi" [ngClass]="isHrUnlocked ? 'bi-unlock-fill' : 'bi-lock-fill'"></i>
          </button>
        </li>

        <!-- HR LINK Section (only when unlocked) -->
        <!-- Employee Management -->
        <li class="sidebar_icon-item" *ngIf="isHrUnlocked && (ModuleIds.EmployeeManagement | canModule : 'VIEW')">
          <a routerLink="/hr-link/emp-management-buttons" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Employee Management">
            <i class="bi bi-people"></i>
          </a>
        </li>
        <!-- Absentee Recorder -->
        <li class="sidebar_icon-item" *ngIf="isHrUnlocked && (ModuleIds.AbsenteeRecorder | canModule : 'VIEW')">
          <a routerLink="/hr-link/emp-attendance" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Absentee Recorder">
              <!-- <a routerLink="/hr-link/absentee-recorder-employees" routerLinkActive="is-active" class="sidebar_icon-link"
            title="Absentee Recorder"> -->
            <i class="bi bi-calendar-x"></i>
          </a>
        </li>
        <!-- HR Admin -->
        <li class="sidebar_icon-item"
          *ngIf="isHrUnlocked && ((ModuleIds.HRSettings | canModule : 'VIEW') || (ModuleIds.PayrollManagement | canModule : 'VIEW'))">
          <a routerLink="/hr-link/hr-admin" routerLinkActive="is-active" class="sidebar_icon-link" title="HR Admin">
            <i class="bi bi-gear"></i>
          </a>
        </li>
        <!-- Payroll Management -->
        <li class="sidebar_icon-item" *ngIf="isHrUnlocked && (ModuleIds.PayrollManagement | canModule : 'VIEW')">
          <ng-container *ngIf="isPayRollEligible(); else payrollLockedIcon">
            <a routerLink="/hr-link/payroll-management" routerLinkActive="is-active" class="sidebar_icon-link"
              title="Payroll Management">
              <i class="bi bi-cash-stack"></i>
            </a>
          </ng-container>
          <ng-template #payrollLockedIcon>
            <span class="sidebar_icon-link" title="Payroll Management (Access Restricted)" style="cursor: not-allowed; opacity: 0.5; position: relative;" (click)="onLockedPayrollClick()">
              <i class="bi bi-cash-stack"></i>
              <i class="bi bi-lock-fill" style="position: absolute; bottom: 2px; right: 2px; font-size: 0.6rem;"></i>
            </span>
          </ng-template>
        </li>
      </ul>
    </nav>

    <!-- Logout Button -->
    <div class="sidebar_logout-collapsed">
      <button type="button" class="sidebar_logout-icon" (click)="logout()" title="Logout">
        <i class="bi bi-box-arrow-left"></i>
      </button>
    </div>
  </div>

  <!-- Expanded State: Show full menu -->
  <ng-container *ngIf="!isCollapsed">
    <!-- Toggle Button (top right) -->
    <button type="button" class="sidebar_toggle-btn" (click)="toggleSidebar()" [attr.aria-expanded]="!isCollapsed"
      aria-label="Collapse sidebar">
      <i class="bi bi-chevron-left"></i>
    </button>

    <!-- Logo -->
    <div class="sidebar_logo">
      <img *ngIf="isPayrollEmployer(); else defaultLogo" src="assets/images/logo_images/PAYROLL 2_new.png"
        alt="Payroll logo" class="sidebar_logo-img" loading="eager" decoding="async" />
      <ng-template #defaultLogo>
        <img src="assets/images/logo_images/PAYDAY 1.png" alt="CIXOR logo" class="sidebar_logo-img"
          loading="eager" decoding="async" style="width: 65%;" />
      </ng-template>
    </div>

    <nav class="sidebar_nav">
      <ul class="sidebar_list">
        <!-- GENERAL (shown only if any child—Home—has VIEW) -->
        <li class="sidebar_section" *ngIf="ModuleIds.Home | canModule : 'VIEW'">
          <div class="sidebar_section-title" [ngClass]="{'restricted': isMenuRestricted('general')}">
            <i class="bi bi-house"></i>
            <span>GENERAL</span>
            <!-- Show padlock for payroll employers -->
            <div class="position-relative d-inline-flex align-items-center" *ngIf="isMenuRestricted('general')">
              <span class="sidebar_padlock" title="Access restricted for payroll users">
                <i class="bi bi-lock-fill"></i>
              </span>
            </div>
          </div>
          <!-- Hide menu items if restricted -->
          <ul class="sidebar_group" *ngIf="!isMenuRestricted('general')">
            <li class="sidebar_item" *ngIf="ModuleIds.Home | canModule : 'VIEW'">
              <a routerLink="dashboard" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="is-active"
                #homeRla="routerLinkActive" [attr.aria-current]="homeRla.isActive ? 'page' : null"
                class="sidebar_link sidebar_link--root">
                Home
              </a>
            </li>
          </ul>
        </li>

                <!-- only for payroll user -->
        <li
          class="sidebar_section"
          *ngIf="(ModuleIds.Home | canModule: 'VIEW') && isPayrollEmployer()"
        >
          <ul class="sidebar_group" >
            <li class="sidebar_item" *ngIf="ModuleIds.Home | canModule: 'VIEW'">
              <a
                routerLink="/admin/payroll-dashboard"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="is-active"
                #homeRla="routerLinkActive"
                [attr.aria-current]="homeRla.isActive ? 'page' : null"
                class="sidebar_link sidebar_link--root"
              >
                Home
              </a>
            </li>
          </ul>
        </li>

        <!-- ADMIN (shown only if ANY child has VIEW) -->
        <li class="sidebar_section" *ngIf="
          (ModuleIds.CompanyDetails | canModule : 'VIEW') ||
          (ModuleIds.ExistingUsers | canModule : 'VIEW') ||
          (ModuleIds.NewUserRequests | canModule : 'VIEW') ||
          (ModuleIds.DocumentManagement | canModule : 'VIEW')
        ">
          <div class="sidebar_section-title">
            <i class="bi bi-person-gear"></i>
            <span>ADMIN</span>
          </div>
          <ul class="sidebar_group">
            <li class="sidebar_item" *ngIf="ModuleIds.CompanyDetails | canModule : 'VIEW'">
              <a routerLink="/admin/company-details" routerLinkActive="is-active" #cdRla="routerLinkActive"
                [attr.aria-current]="cdRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--root">
                Company Details
              </a>
            </li>

            <!-- USER MANAGEMENT group (shown only if ANY child has VIEW) -->
            <li class="sidebar_item" *ngIf="
              (ModuleIds.ExistingUsers | canModule : 'VIEW') ||
              (ModuleIds.NewUserRequests | canModule : 'VIEW')
            ">
              <!-- Toggle looks/behaves like a nav item -->
              <button type="button" class="sidebar_toggle sidebar_link sidebar_link--root" (click)="toggle('admin')"
                [attr.aria-expanded]="state.adminOpen" aria-controls="admin_submenu">
                <span class="sidebar_toggle-label">User Management</span>
                <i class="bi" [ngClass]="
                  state.adminOpen ? 'bi-chevron-up' : 'bi-chevron-down'
                "></i>
              </button>

              <ul id="admin_submenu" class="sidebar_sublist" *ngIf="state.adminOpen">
                <li class="sidebar_item" *ngIf="ModuleIds.ExistingUsers | canModule : 'VIEW'">
                  <a routerLink="/admin/user-management/existing-users" routerLinkActive="is-active"
                    #euRla="routerLinkActive" [attr.aria-current]="euRla.isActive ? 'page' : null"
                    class="sidebar_link sidebar_link--sub">
                    Existing Users
                  </a>
                </li>
                <li class="sidebar_item" *ngIf="ModuleIds.NewUserRequests | canModule : 'VIEW'">
                  <a routerLink="/admin/user-management/new-user-requests" routerLinkActive="is-active"
                    #nurRla="routerLinkActive" [attr.aria-current]="nurRla.isActive ? 'page' : null"
                    class="sidebar_link sidebar_link--sub">
                    New User Requests
                  </a>
                </li>
              </ul>
            </li>

            <!-- <li
            class="sidebar_item"
            *ngIf="ModuleIds.DocumentManagement | canModule : 'VIEW'"
          >
            <a
              routerLink="/admin/document-manage"
              routerLinkActive="is-active"
              #dmRla="routerLinkActive"
              [attr.aria-current]="dmRla.isActive ? 'page' : null"
              class="sidebar_link sidebar_link--root"
            >
              Document Management
            </a>
          </li> -->
          </ul>
        </li>

        <!-- TRANSACTION (shown only if ANY child has VIEW) -->
        <li class="sidebar_section" *ngIf="
          (ModuleIds.EarnWageWithdrawal | canModule : 'VIEW') ||
          (ModuleIds.WageWithdrawalRollovers | canModule : 'VIEW') ||
          (ModuleIds.TotalWages | canModule : 'VIEW') ||
          (ModuleIds.CIXORPayments | canModule : 'VIEW') ||
          (ModuleIds.WagesWithdrawalsRollovers | canModule : 'VIEW')
        ">
          <div class="sidebar_section-title" [ngClass]="{'restricted': isMenuRestricted('transactions')}">
            <i class="bi bi-cash-coin"></i>
            <span>TRANSACTION</span>
            <!-- Show padlock for payroll employers -->
            <div class="position-relative d-inline-flex align-items-center" *ngIf="isMenuRestricted('transactions')">
              <span class="sidebar_padlock" title="Access restricted for payroll users">
                <i class="bi bi-lock-fill"></i>
              </span>
            </div>
          </div>
          <!-- Hide menu items if restricted -->
          <ul class="sidebar_group" *ngIf="!isMenuRestricted('transactions')">
            <!-- <li
            class="sidebar_item"
            *ngIf="ModuleIds.WageWithdrawalRollovers | canModule : 'VIEW'"
          >
            <a
              routerLink="/transactions/rollover-request"
              routerLinkActive="is-active"
              #ewwRla="routerLinkActive"
              [attr.aria-current]="ewwRla.isActive ? 'page' : null"
              class="sidebar_link sidebar_link--sub"
            >
              Rollover Request
            </a>
          </li> -->

            <!-- Pay Day Quick View Manu Item -->
            <li class="sidebar_item" *ngIf="ModuleIds.PayDayQuickView | canModule : 'VIEW'">
              <a routerLink="/transactions/pay-day-quick-view" routerLinkActive="is-active" #ewwRla="routerLinkActive"
                [attr.aria-current]="ewwRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--sub">
                Pay Day Quick View
              </a>
            </li>

            <!-- Earn Wage Withdrawal -->
            <li class="sidebar_item" *ngIf="ModuleIds.EarnWageWithdrawal | canModule : 'VIEW'">
              <a routerLink="/transactions/earned-wage-withdrawals" routerLinkActive="is-active"
                #ewwRla="routerLinkActive" [attr.aria-current]="ewwRla.isActive ? 'page' : null"
                class="sidebar_link sidebar_link--sub">
                Earn Wage Withdrawal
              </a>
            </li>

            <!-- Total Wages -->
            <li class="sidebar_item" *ngIf="ModuleIds.TotalWages | canModule : 'VIEW'">
              <a routerLink="/transactions/total-wages" routerLinkActive="is-active" #twRla="routerLinkActive"
                [attr.aria-current]="twRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--sub">
                Total Wages
              </a>
            </li>

            <!-- Wage Withdrawals & Rollovers -->
            <li class="sidebar_item" *ngIf="ModuleIds.WageWithdrawalRollovers | canModule : 'VIEW'">
              <a routerLink="/transactions/wage-withdrawal-rollovers" routerLinkActive="is-active"
                #wwrRla="routerLinkActive" [attr.aria-current]="wwrRla.isActive ? 'page' : null"
                class="sidebar_link sidebar_link--sub">
                Wage Withdrawal Rollovers
              </a>
            </li>

            <!-- Wages - Withdrawals - Rollovers -->
            <li class="sidebar_item" *ngIf="ModuleIds.WagesWithdrawalsRollovers | canModule : 'VIEW'">
              <a routerLink="/transactions/wages-withdrawals-rollovers" routerLinkActive="is-active"
                #wwr2Rla="routerLinkActive" [attr.aria-current]="wwr2Rla.isActive ? 'page' : null"
                class="sidebar_link sidebar_link--sub">
                Wages - Withdrawals - Rollovers
              </a>
            </li>
            
            <!-- CIXOR Payments -->
            <li class="sidebar_item" *ngIf="ModuleIds.CIXORPayments | canModule : 'VIEW'">
              <a routerLink="/transactions/cixor-payments" routerLinkActive="is-active" #cpRla="routerLinkActive"
                [attr.aria-current]="cpRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--sub">
                CIXOR Payments
              </a>
            </li>

            <!-- Late Fee Payments -->
            <li class="sidebar_item" *ngIf="ModuleIds.LatePaymentFees | canModule : 'VIEW'">
              <a routerLink="/transactions/late-payment-fees" routerLinkActive="is-active" #lfRla="routerLinkActive"
                [attr.aria-current]="lfRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--sub">
                Late Fee Payments
              </a>
            </li>
          </ul>
        </li>

        <!-- HR LINK -->

        <!-- HR LINK -->
        <!-- HR LINK Section with 4 buttons when logged in -->
        <li class="sidebar_section" *ngIf="
          (ModuleIds.EmployeeManagement | canModule : 'VIEW') ||
          (ModuleIds.AbsenteeRecorder | canModule : 'VIEW') ||
          (ModuleIds.HRAdmin | canModule : 'VIEW') ||
          (ModuleIds.PayrollManagement | canModule : 'VIEW')
        ">
          <div class="sidebar_section-title">
            <i class="bi bi-person-workspace"></i>
            <span class="cursor-pointer" >{{ isPayrollEmployer() ? 'PAYROLL LINK' : 'HR LINK' }}</span>
            <!-- (click)="goToHrDashboard()" add this any bug occured -->

            <!-- Show lock/unlock buttons only for non-payroll employers -->
            <ng-container *ngIf="!isPayrollEmployer()">
              <!-- Show padlock button when not logged in -->
              <div class="position-relative d-inline-flex align-items-center" *ngIf="!isHrUnlocked">
                <button type="button" class="sidebar_icon-button" (click)="handleHrLinkClick()"
                  [attr.aria-label]="'Access HR Link'" [title]="'Access HR Link'">
                  <i class="bi bi-lock-fill"></i>
                </button>
              </div>

              <!-- Show lock/unlock toggle when logged in -->
              <div class="position-relative d-inline-flex align-items-center" *ngIf="isHrUnlocked">
                <button type="button" class="sidebar_icon-button is-unlocked" (click)="handleHrLinkClick()"
                  [attr.aria-label]="'Lock HR Access'" [title]="'Lock HR Access'">
                  <i class="bi bi-unlock-fill"></i>
                </button>
              </div>
            </ng-container>
          </div>

          <!-- HR Menu Items - Show when HR is unlocked OR user is payroll employer (employerTypeId = 2) -->
          <ul class="sidebar_group" *ngIf="isHrUnlocked || isPayrollEmployer()">
            <li class="sidebar_item" *ngIf="ModuleIds.EmployeeManagement | canModule : 'VIEW'">
              <a routerLink="/hr-link/emp-management-buttons" routerLinkActive="is-active" #emRla="routerLinkActive"
                [attr.aria-current]="emRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--root">
                <i class="bi bi-people"></i>
                Employee Management
              </a>
            </li>

            <li class="sidebar_item" *ngIf="ModuleIds.AbsenteeRecorder | canModule : 'VIEW'">
              <a routerLink="/hr-link/emp-attendance" routerLinkActive="is-active"
                #arRla="routerLinkActive" [attr.aria-current]="arRla.isActive ? 'page' : null"
                class="sidebar_link sidebar_link--root">
                <i class="bi bi-calendar-x"></i>
                Attendance Management
              </a>
            </li>

            <li class="sidebar_item"
              *ngIf="(ModuleIds.HRSettings| canModule : 'VIEW') ||(ModuleIds.HRAdmin| canModule : 'VIEW')  ">
              <a routerLink="/hr-link/hr-admin-buttons" routerLinkActive="is-active" #haRla="routerLinkActive"
                [attr.aria-current]="haRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--root">
                <i class="bi bi-gear"></i>
                HR Admin
              </a>
            </li>

            <li class="sidebar_item" *ngIf="(ModuleIds.HRSupportMessages | canModule : 'VIEW') || (ModuleIds.HRAdmin | canModule : 'VIEW')">
              <a routerLink="/hr-link/hr-support-messages" routerLinkActive="is-active" #hsRla="routerLinkActive"
                [attr.aria-current]="hsRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--root">
                <i class="bi bi-chat-dots"></i>
                HR Support Messages
              </a>
            </li>

            <li class="sidebar_item" *ngIf="ModuleIds.PayrollManagement | canModule : 'VIEW'">
              <ng-container *ngIf="isPayRollEligible(); else payrollLockedLink">
                <a routerLink="/hr-link/payroll-management" routerLinkActive="is-active" #pmRla="routerLinkActive"
                  [attr.aria-current]="pmRla.isActive ? 'page' : null" class="sidebar_link sidebar_link--root">
                  <i class="bi bi-cash-stack"></i>
                  Payroll Management
                </a>
              </ng-container>
              <ng-template #payrollLockedLink>
                <span class="sidebar_link sidebar_link--root" style="cursor: not-allowed; opacity: 0.5;" (click)="onLockedPayrollClick()">
                  <i class="bi bi-cash-stack"></i>
                  Payroll Management
                  <i class="bi bi-lock-fill ms-1" style="font-size: 0.75rem;"></i>
                </span>
              </ng-template>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <!-- Logout -->
     <div class="btn-wrapper">
          <div class="sidebar_logout">
      <button type="button" class="sidebar_logout-btn" (click)="logout()">
        <i class="bi bi-box-arrow-left"></i>
        <span>Logout</span>
      </button>
    </div>
    </div>
  </ng-container>
</aside>